/**
 * A download that tries again: on a phone's patchy connection one file (a model, an animation, a texture) failing was
 * the end of it until a reload (the failed promise was kept), and it surfaced as an "Event" rejection nobody caught.
 * Three tries, a little longer between each.
 */
export async function retry<T>(f: () => Promise<T>, tries = 3): Promise<T> {
  for (let i = 0; ; i++) {
    try { return await f(); } catch (e) {
      if (i >= tries - 1) throw e instanceof Error ? e : new Error(`load failed: ${(e as Event)?.type ?? String(e)}`);
      await new Promise((ok) => setTimeout(ok, 700 * (i + 1)));
    }
  }
}

/** setPointerCapture throws when the pointer is already gone (a finger lifted before the handler ran): harmless */
export function capture(el: Element, id: number) { try { el.setPointerCapture(id); } catch { /* the pointer's gone */ } }
